__turbopack_context__.v({
  "closeIconButtonDesktop": "PromoBar-module-scss-module__zUbjTG__closeIconButtonDesktop",
  "closeIconButtonMobile": "PromoBar-module-scss-module__zUbjTG__closeIconButtonMobile",
  "contentContainer": "PromoBar-module-scss-module__zUbjTG__contentContainer",
  "endContent": "PromoBar-module-scss-module__zUbjTG__endContent",
  "endContentDesktop": "PromoBar-module-scss-module__zUbjTG__endContentDesktop",
  "expandedPromoBarContainer": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarContainer",
  "expandedPromoBarHeader": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarHeader",
  "expandedPromoBarItem": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItem",
  "expandedPromoBarItemDivider": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItemDivider",
  "expandedPromoBarItemDividerLast": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItemDividerLast",
  "expandedPromoBarItemLink": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItemLink",
  "expandedPromoBarItemMessage": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItemMessage",
  "expandedPromoBarItemTitle": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarItemTitle",
  "expandedPromoBarOverlay": "PromoBar-module-scss-module__zUbjTG__expandedPromoBarOverlay",
  "keepWithIcon": "PromoBar-module-scss-module__zUbjTG__keepWithIcon",
  "messageButton": "PromoBar-module-scss-module__zUbjTG__messageButton",
  "messageButtonIcon": "PromoBar-module-scss-module__zUbjTG__messageButtonIcon",
  "messageItem": "PromoBar-module-scss-module__zUbjTG__messageItem",
  "promoBar": "PromoBar-module-scss-module__zUbjTG__promoBar",
  "promoBarSection": "PromoBar-module-scss-module__zUbjTG__promoBarSection",
  "skipLink": "PromoBar-module-scss-module__zUbjTG__skipLink",
  "startContent": "PromoBar-module-scss-module__zUbjTG__startContent",
  "visuallyHidden": "PromoBar-module-scss-module__zUbjTG__visuallyHidden",
});
